/*
 *
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 *
 */

import sodium from 'libsodium-wrappers';

async function doEncrypt(value) {
  await sodium.ready;
  const keypair = sodium.crypto_box_keypair();
  const privateKey = keypair.privateKey;
  const publicKey = keypair.publicKey;

  const hexPublicKey = sodium.to_hex(publicKey);

  const nonce = sodium.randombytes_buf(sodium.crypto_box_NONCEBYTES);
  let serverKey = '';
  await fetch('/e2eeClientKey', {
    method: 'GET'
  }).then((resp) => {
    if (!resp.ok) {
      throw Error(resp.statusText);
    }
    return resp.text();
  })
    .then((data) => {
      serverKey = data;
    });

  const myCryptoBox = sodium.crypto_box_easy(sodium.from_string(value), nonce, sodium.from_hex(serverKey), privateKey, 'hex');

  return `${hexPublicKey}::${sodium.to_hex(nonce)}::${myCryptoBox}::${value.length}`;
}

async function doDecrypt(value, keypair) {
  await sodium.ready;
  const privateKey = sodium.from_hex(keypair.privateKey);
  const arr = value.split('::');
  const publicKey = sodium.from_hex(arr.at(0));
  const nonce = sodium.from_hex(arr.at(1));
  const cipherText = sodium.from_hex(arr.at(2));
  const decryptedValue = sodium.crypto_box_open_easy(cipherText, nonce, publicKey, privateKey);
  return sodium.to_string(decryptedValue);
}


async function generateKeyPair() {
  await sodium.ready;
  const keypair = sodium.crypto_box_keypair();
  return {
    privateKey: sodium.to_hex(keypair.privateKey),
    publicKey: sodium.to_hex(keypair.publicKey)
  };
}

export { doEncrypt, doDecrypt, generateKeyPair };
